import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ContentfulImage from './components/ContentfulImage/ContentfulImage';
const BlogSlideComponent = t0 => {
  const $ = _c(9);
  const {
    link,
    title,
    image
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("block float-left w-full !text-gray no-underline hover:!no-underline focus-visible:rounded-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]", "flex-[1_1] flex-col box-content justify-between items-center min-w-[80%] sm:min-w-[33.333%] lg:min-w-[25%] px-2.5", "[&_img]:object-cover [&_img]:block [&_img]:aspect-square");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== image) {
    t2 = <ContentfulImage alt="" src={image} width={480} height={260} />;
    $[1] = image;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <p className="text-lg font-bold">{title}</p>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== link || $[6] !== t2 || $[7] !== t3) {
    t4 = <div className={t1}><Link to={link} className="block focus-visible:rounded-[5px] focus-visible:mb-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]">{t2}{t3}</Link></div>;
    $[5] = link;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
BlogSlideComponent.propTypes = {
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default BlogSlideComponent;